<template>
  <div class="NavHeader">
    <div class="top">
      <div class="container box">
        <div class="logo"><img src="@/assets/image/logo2.png" /></div>
        <div class="title">皇太后餐點管理系統</div>
        <div class="nav">
          <div class="_txt"><span>{{ dateTime }}</span><span>{{ week }}</span><span>{{ time.timeInterval +' '+ time.time }} {{$store.state.user.name}}，您好</span></div>
          <ul>
            <li><a @click="loginOut"><i class="iconfont icon-out"></i></a></li>
<!--            <li><a href="#"><i class="iconfont icon-s2"></i></a></li>-->
            <li><router-link to="/"><i class="iconfont icon-home"></i></router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="container box">
        <div class="explain" v-if="$route.path !='/System' && $route.path !='/Meal'">
          <p v-if="$route.path == '/Notice'">歡迎使用皇太后餐點管理系統，若您對於系統使用有任何疑問，請洽皇太后負責業務為您服務；或利用畫面上右上方的「使用說明」。</p>
          <p v-else-if="$route.path == '/Catering'">依據館內 / 館內試吃 / 院外餐 / 陪宿等各訂餐身份，快速進行餐點之增減、編輯等餐務管理。</p>
          <p v-else-if="$route.path == '/Catering/List'">預覽今日出餐訂單摘要，可快速執行捷徑指令，也可進階查看或編輯 客戶訂單詳情（個人資料、餐飲禁忌、出餐調整等）。</p>
        </div>
        <div class="rili" v-if="$route.path =='/Meal'">
           <div>
              <span>{{ $store.state.dataTime.year }}</span>
              <span>{{ $store.state.dataTime.month }}月</span>
           </div>
           <h2>
             {{ $store.state.dataTime.day }}
           </h2>
          <p>{{ $store.state.dataTime.week }}</p>
        </div>
        <div class="nav">
          <router-link  to="/Notice" class="item" :class="{ 'active': isPathActive('/Notice') }" v-if="$isPermission('agency_message')">
            <img src="@/assets/image/nav-1.svg" />
            <div class="txt">皇太后公告</div>
          </router-link>
          <router-link to="/Catering" class="item" :class="{ 'active': isPathActive('/Catering') }" v-if="$isPermission('agency_meal_manage')">
            <img src="@/assets/image/nav-2.svg" />
            <div class="txt">餐務管理</div>
          </router-link>
          <router-link to="/Meal" class="item" :class="{ 'active': isPathActive('/Meal') }" v-if="$isPermission('agency_meal_query')">
            <img src="@/assets/image/nav-3.svg" />
            <div class="txt">餐況查詢</div>
          </router-link>
          <router-link to="/System" class="item" :class="{ 'active': isPathActive('/System') }" v-if="$isPermission('agency_system')">
            <img src="@/assets/image/nav-4.svg" />
            <div class="txt">系統後台</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { logout } from "@/api";
import { getNowDate, getCount } from '@/utils/index'
export default {
  name: "NavHeader",

  data() {
    return {
      week: '',
      dateTime: '',
      time: ''
    }
  },
  created(){
    this.gettime()
  },
  methods: {
    isPathActive(path) {
      return this.$route.path.includes(path);
    },
    loginOut(){
      logout().then(res =>{
        if(res.code == 200){
          this.$router.push('/login')
          window.localStorage.removeItem('token')
          window.localStorage.removeItem('agency_info')
        }
      })

    },

    gettime() {
      const date = getNowDate()
      this.week = date.week
      this.dateTime = date.dateString
      this.time = getCount()
      const intervalTime = setInterval(() => {
        this.time = getCount()
        const todayDate = new Date().setHours(0, 0, 0, 0)
        const paramsDate = new Date(this.dataTime).setHours(0, 0, 0, 0)
        const isToday = (todayDate === paramsDate)
        if (!isToday) {
          clearInterval(intervalTime)
          this.gettime()
        }
      }, 1000)
    },
  },
  computed:{

  },
  watch:{

  }
}
</script>

<style lang="scss" scoped>
.rili{
  color: red;
  border: 1px solid #DBBD80;
  border-radius: 15px;
  letter-spacing: 2px;
  height: 140px;
  width: 150px;
  div{
    display: flex;
    align-items: center;
    justify-content: center;
    background: #DBBD80;
    border-radius: 14px 14px 0 0;
    color: #FFFFFF;
    span{
      padding: 2px 10px;
      margin: 5px;
    }
    span:first-child{
      border-right: 1px solid #ffffff;
    }
  }
  h2{
    font-size: 45px;
    margin: 0px auto;
    color: #000000;
  }
  p{
    color: #b6b8bd;
    margin-top: 0;
  }
}
</style>
